import type { BusinessInsightsDashboard } from '../types';
import getMockAttentionItems from './getMockAttentionItems';
import getMockCohorts from './getMockCohorts';
import getMockEngagementStats from './getMockEngagementStats';
import getMockMovers from './getMockMovers';
import getMockOrganizations from './getMockOrganizations';
import getMockRetentionStats from './getMockRetentionStats';
import getMockSectionInsights from './getMockSectionInsights';
import getMockUnitEconomics from './getMockUnitEconomics';
import getMockUnitEconomicsStats from './getMockUnitEconomicsStats';

const getMockBusinessInsightsDashboard = (): BusinessInsightsDashboard => {
    const sectionInsights = getMockSectionInsights();

    return {
        periodLabel: 'July 2026 · last complete month',
        currency: 'usd',
        unitEconomics: getMockUnitEconomics(),
        unitEconomicsStats: getMockUnitEconomicsStats(),
        unitEconomicsInsight: sectionInsights.unitEconomicsInsight,
        retentionStats: getMockRetentionStats(),
        retentionInsight: sectionInsights.retentionInsight,
        cohorts: getMockCohorts(),
        cohortMaxMonths: 6,
        engagementStats: getMockEngagementStats(),
        engagementInsight: sectionInsights.engagementInsight,
        organizations: getMockOrganizations(),
        organizationsInsight: sectionInsights.organizationsInsight,
        attentionItems: getMockAttentionItems(),
        movers: getMockMovers(),
    };
};

export default getMockBusinessInsightsDashboard;
